/* eslint-disable */
import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App'
import axios from 'axios'


import './plugins'
import './assets/style/layout.scss'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'amfe-flexible/index.js'
import 'swiper/swiper.min.css';
import 'vant/lib/index.css';
import vueEsign from 'vue-esign'
// import Vconsole from 'vconsole'

// let vConsole = new Vconsole()
// export default vConsole

Vue.config.productionTip = false
Vue.prototype.$ajax = axios
Vue.use(vueEsign)


/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/feiyi2/main.js